module.exports = __webpack_public_path__ + "img/ertiga-xl7-boostergreen-tittle.3cdbfb13.svg";